export const LAUNCHPICKERINPUT = "LaunchPickerInput";
export const LAUNCHDATEPICKERINPUT = "LaunchDatePickerInput";
